<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="list-margin">
    <DataTable
      :value="recipe"
      class="p-datatable-lg p-datatable-customers"
      dataKey="id"
      :rowHover="true"
      :resizableColumns="false"
      @sort="onSort($event)"
    >
      <template #header>
        <div class="grid m-0">
          <div class="lg:col-6 col-12 lg:text-left text-center list-header">
            Recipes / Items
          </div>
          <div class="lg:col-6 col-12 lg:text-right text-center">
            <!-- <PrimeButton
              class="download-button col-1 p-0"
              icon="pi pi-upload"
              @click="openFileUpload"
            >
            </PrimeButton>
            <FileUpload
              ref="photo"
              name="photo"
              @select="onAdvancedUpload($event)"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              v-show="false"
            />
            <PrimeButton
              class="download-button col-1 p-0"
              icon="pi pi-download"
              @click="gotoGenerateExcel"
            >
            </PrimeButton> -->
            <PrimeButton
              label=" ADD "
              class="add-button mr-3"
              icon="plus-icon"
              @click="gotoCreateRecipe"
            ></PrimeButton>
            <div class="p-input-icon-right">
              <i class="search-icon cursor-pointer" @click="onSearch" />
              <InputText
                v-model="search"
                placeholder="Search"
                class="search-input"
                @keyup="onSearch"
              />
            </div>
            <PrimeButton
              class="download-button ml-3"
              icon="pi pi-download"
              @click="downloadCSV"
              :disabled="recipe.length == 0"
            ></PrimeButton>
          </div>
        </div>
      </template>

      <template #loading> Loading records, please wait... </template>
      <template #empty> No records found. </template>
      <Column field="name" header="Name" sortable></Column>
      <Column
        field="noofperson"
        header="Number Of Person"
        class="numberperson"
        sortable
      >
      </Column>
      <Column field="actions" header="Actions">
        <template #body="data">
          <div class="flex">
            <!-- v-tooltip.top="'Copy Recipe'" -->
            <i
              class="pi pi-copy cursor-pointer copy-icon"
              style="color: #0000ff"
              @click="gotoRecipeCopy(data.data.id)"
            ></i>
            <i
              class="pi pi-pencil cursor-pointer edit-icon ml-1"
              style="color: gray"
              @click="gotoRecipeEdit(data.data.id)"
            ></i>
            <i
              class="pi pi-trash cursor-pointer delete-icon ml-1"
              style="color: #dc3545"
              @click="showDeletePopup(data.data.id)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
    <Paginator
      v-model:first="currentPage"
      :rows="50"
      :totalRecords="totalRecords"
      :rowsPerPageOptions="[50, 100, 150, 200]"
      template="RowsPerPageDropdown CurrentPageReport PageLinks"
      currentPageReportTemplate="{first} - {last} of {totalRecords} items"
      @page="onPage($event)"
      :class="{
        loading: loading,
      }"
    >
      <template #start> Shown per page : </template>
    </Paginator>
    <ConfirmPopup
      :show-popup="showPopup"
      @confirmYes="deleteVendor"
      @confirmNo="showPopup = false"
    ></ConfirmPopup>
  </div>
</template>
<script>
import APIService from "@/services/api-service.js";
import RecipeFactory from "@/factories/recipe";
export default {
  data() {
    return {
      loading: false,
      recipe: [],
      recipelist: [],
      totalRecordsStore: 0,
      currentPage: 0,
      itemsPerPage: 50,
      search: "",
      searchText: "",
      totalRecords: 0,
      sortColumn: "id",
      sortDir: "asc",
      showPopup: false,
      recipeIdForDelete: "",
    };
  },

  mounted() {
    this.getRecipeList();
  },
  methods: {
    downloadCSV() {
      this.$root.$globalState.loader = true;
      APIService.get(`/recipe/downloadcsv`)
        .then((response) => {
          if (response && response.data && response.data.success) {
            window.open(response.data.data.file);
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
        });
    },
    gotoCreateRecipe() {
      this.$router.push({ name: "RecipeCreate" });
    },
    gotoRecipeCopy(rowId) {
      this.$router.push({
        name: "RecipeCopy",
        params: { id: rowId },
      });
    },
    gotoRecipeEdit(rowId) {
      this.$router.push({
        name: "RecipeEdit",
        params: { id: rowId },
      });
    },
    showDeletePopup(rowId) {
      this.recipeIdForDelete = rowId;
      this.showPopup = true;
    },
    getRecipeList() {
      this.$root.$globalState.loader = true;
      this.recipe = [];
      APIService.get(
        `/recipe/${this.currentPage}/${this.itemsPerPage}/${this.sortColumn}/${this.sortDir}/${this.searchText}`
      )
        .then((response) => {
          if (response && response.data) {
            this.totalRecords = response.data.totalrecord;
            this.recipe = RecipeFactory.createFromJsonArray(response.data.data);
            if (this.search.length == 0) {
              this.recipelist = RecipeFactory.createFromJsonArray(
                response.data.data
              );
              this.totalRecordsStore = response.data.totalrecord;
            }
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
        });
    },
    deleteVendor() {
      this.$root.$globalState.loader = true;
      APIService.delete(`/recipe/delete/${this.recipeIdForDelete}`)
        .then((response) => {
          if (response && response.data && response.data.success) {
            this.getRecipeList();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.$root.$globalState.loader = false;
          this.showPopup = false;
        });
    },
    onPage(pageData) {
      this.itemsPerPage = pageData.rows;
      this.currentPage = pageData.first;
      this.getRecipeList();
    },
    onSort(sortData) {
      let sortField = sortData.sortField;
      if (sortData.sortField === "createddate") {
        sortField = "createddate";
      }
      this.sortColumn = sortField;
      this.sortDir = sortData.sortOrder === 1 ? "asc" : "dsc";
      this.currentPage = 0;

      this.getRecipeList();
    },
    onSearch() {
      // this.search = this.search.trimStart().trimEnd();
      // this.currentPage = 0;
      // this.getRecipeList();
      let search = this.search.trimStart().trimEnd();
      this.currentPage = 0;
      if (search.length >= 2) {
        this.searchText = this.search.trimStart().trimEnd();
        this.getRecipeList();
      } else if (search.length == 0) {
        this.searchText = this.search.trimStart().trimEnd();
        this.getRecipeList();
      } else if (search.length < 2) {
        this.searchText = "";
        this.recipe = this.recipelist;
        this.totalRecords = this.totalRecordsStore;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/datatable.scss";
:deep(
    .p-datatable.p-datatable-customers .p-datatable-thead tr th.numberperson
  ) {
  min-width: 200px;
}
</style>
